// import update from "immutability-helper";
import {
  SET_SHIPPING_RATES,
} from "../actionTypes/ShippingActionTypes";

const initialState = {
  shippingRates: { 
    isShow: false,
    rateList: [],
    fieldGroups: [],
    addressDetails: {},
  },
};

// Assign the reducer function to a named variable
const ShippingReducer = (state = initialState, action) => {
  const { shippingRates } = state;
  const { payload, type } = action;
  let updateRatesState = null;

  switch (type) {
    case SET_SHIPPING_RATES:
      updateRatesState = {
        ...shippingRates,
        ...payload,
      };
      return {
        ...state,
        shippingRates: { ...updateRatesState },
      };
    default:
      return state;
  }
};

// Export the named function as the default export
export default ShippingReducer;
